const fr = {
  "common": {
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "add": "Ajouter",
    "search": "Rechercher",
    "loading": "Chargement...",
    "error": "Erreur",
    "success": "Succès",
    "confirm": "Confirmer",
    "back": "Retour",
    "next": "Suivant",
    "previous": "Précédent",
    "close": "Fermer",
    "submit": "Soumettre",
    "update": "Mettre à jour",
    "view": "Voir",
    "download": "Télécharger",
    "upload": "Téléverser",
    "select": "Sélectionner",
    "all": "Tout",
    "none": "Aucun",
    "yes": "Oui",
    "no": "Non"
  },
  "nav": {
    "dashboard": "Tableau de bord",
    "createAd": "Créer une annonce",
    "campaigns": "Campagnes",
    "insights": "Analyses",
    "contextiq": "ContextIQ",
    "adGallery": "Galerie d'annonces",
    "university": "Université",
    "managedServices": "Services gérés",
    "resources": "Ressources",
    "settings": "Paramètres",
    "signOut": "Déconnexion",
    "help": "Aide et ressources"
  },
  "header": {
    "searchPlaceholder": "Rechercher campagnes, créatifs...",
    "notifications": "Notifications",
    "viewAllNotifications": "Voir toutes les notifications",
    "accountSettings": "Paramètres du compte",
    "manageSubscription": "Gérer l'abonnement",
    "upgradePlan": "Améliorer le forfait",
    "updateProfile": "Mettre à jour le profil",
    "takeTour": "Faire la visite",
    "language": "Langue"
  },
  "dashboard": {
    "title": "Tableau de bord",
    "welcome": "Bon retour",
    "overview": "Aperçu",
    "recentCampaigns": "Campagnes récentes",
    "topPerformingAds": "Annonces les plus performantes",
    "quickActions": "Actions rapides",
    "createNewAd": "Créer une nouvelle annonce",
    "viewCampaigns": "Voir les campagnes",
    "viewInsights": "Voir les analyses",
    "impressions": "Impressions",
    "clicks": "Clics",
    "ctr": "CTR",
    "spend": "Dépenses",
    "conversions": "Conversions",
    "revenue": "Revenus",
    "performance": "Performance",
    "thisMonth": "Ce mois",
    "lastMonth": "Mois dernier",
    "contextiqWidget": {
      "title": "Analyses ContextIQ",
      "brandMatches": "Correspondances de marque",
      "alignmentScore": "Score d'alignement",
      "topOpportunities": "Meilleures opportunités",
      "viewAll": "Voir tout"
    }
  },
  "campaigns": {
    "title": "Campagnes",
    "subtitle": "Gérez et surveillez vos campagnes publicitaires",
    "createCampaign": "Créer une campagne",
    "allCampaigns": "Toutes les campagnes",
    "active": "Active",
    "paused": "En pause",
    "completed": "Terminée",
    "draft": "Brouillon",
    "scheduled": "Programmée",
    "status": "Statut",
    "budget": "Budget",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "noCampaigns": "Pas encore de campagnes",
    "createFirst": "Créez votre première campagne pour commencer"
  },
  "insights": {
    "title": "Analyses",
    "subtitle": "Analysez les performances de vos campagnes",
    "campaigns": "Campagnes",
    "creatives": "Créatifs",
    "audience": "Audience",
    "dateRange": "Période",
    "export": "Exporter",
    "metrics": {
      "totalImpressions": "Impressions totales",
      "totalClicks": "Clics totaux",
      "averageCtr": "CTR moyen",
      "totalSpend": "Dépenses totales",
      "costPerClick": "Coût par clic",
      "conversionRate": "Taux de conversion"
    }
  },
  "contextiq": {
    "title": "ContextIQ",
    "subtitle": "Ciblage contextuel alimenté par l'IA",
    "brandAnalysis": "Analyse de marque",
    "contentMatching": "Correspondance de contenu",
    "opportunities": "Opportunités",
    "safetyScore": "Score de sécurité de marque",
    "alignmentScore": "Score d'alignement",
    "analyzeUrl": "Analyser l'URL",
    "enterUrl": "Entrez l'URL à analyser",
    "analyze": "Analyser",
    "results": "Résultats",
    "noResults": "Pas encore de résultats",
    "startAnalyzing": "Entrez une URL ci-dessus pour commencer l'analyse"
  },
  "gallery": {
    "title": "Galerie d'annonces",
    "subtitle": "Parcourez et gérez vos ressources créatives",
    "uploadNew": "Téléverser nouveau",
    "allCreatives": "Tous les créatifs",
    "images": "Images",
    "videos": "Vidéos",
    "html5": "HTML5",
    "templates": "Modèles",
    "sortBy": "Trier par",
    "newest": "Plus récent",
    "oldest": "Plus ancien",
    "name": "Nom",
    "noCreatives": "Pas encore de créatifs",
    "uploadFirst": "Téléversez votre premier créatif pour commencer"
  },
  "university": {
    "title": "Université Adventive",
    "subtitle": "Maîtrisez la publicité interactive",
    "courses": "Cours",
    "certifications": "Certifications",
    "resources": "Ressources",
    "progress": "Votre progression",
    "completedCourses": "Cours terminés",
    "inProgress": "En cours",
    "startLearning": "Commencer à apprendre",
    "continueLearning": "Continuer à apprendre",
    "viewCourse": "Voir le cours",
    "certificate": "Certificat"
  },
  "managedServices": {
    "title": "Services gérés",
    "subtitle": "Laissez nos experts créer vos annonces",
    "newRequest": "Nouvelle demande",
    "activeRequests": "Demandes actives",
    "completedRequests": "Demandes terminées",
    "requestStatus": {
      "pending": "En attente",
      "inProgress": "En cours",
      "review": "En révision",
      "completed": "Terminée",
      "needsInput": "Besoin d'informations"
    },
    "submitRequest": "Soumettre la demande",
    "requestDetails": "Détails de la demande"
  },
  "settings": {
    "title": "Paramètres",
    "subtitle": "Gérez les préférences de votre compte",
    "profile": "Profil",
    "organization": "Organisation",
    "team": "Équipe",
    "notifications": "Notifications",
    "security": "Sécurité",
    "billing": "Facturation",
    "preferences": "Préférences",
    "language": "Langue",
    "timezone": "Fuseau horaire",
    "theme": "Thème",
    "darkMode": "Mode sombre",
    "lightMode": "Mode clair",
    "systemDefault": "Système par défaut",
    "restartTour": "Relancer la visite de la plateforme",
    "restartTourDesc": "Faites une visite guidée des fonctionnalités de la plateforme",
    "profileInfo": {
      "title": "Informations du profil",
      "subtitle": "Mettez à jour vos informations personnelles et préférences",
      "firstName": "Prénom",
      "lastName": "Nom",
      "email": "Adresse e-mail",
      "phone": "Téléphone",
      "changePhoto": "Changer la photo",
      "photoHint": "JPG, PNG ou GIF. Max 2 Mo."
    },
    "organizationInfo": {
      "title": "Détails de l'organisation",
      "subtitle": "Gérez les informations de votre organisation",
      "name": "Nom de l'organisation",
      "type": "Type d'organisation",
      "industry": "Industrie",
      "website": "Site web",
      "address": "Adresse"
    },
    "teamMembers": {
      "title": "Membres de l'équipe",
      "subtitle": "Gérez votre équipe",
      "inviteMember": "Inviter un membre",
      "role": "Rôle",
      "admin": "Administrateur",
      "editor": "Éditeur",
      "viewer": "Visualiseur",
      "pending": "En attente"
    },
    "notificationPrefs": {
      "title": "Préférences de notification",
      "subtitle": "Choisissez comment vous souhaitez être notifié",
      "campaignUpdates": "Mises à jour de campagne",
      "campaignUpdatesDesc": "Soyez notifié lorsque les campagnes sont lancées, mises en pause ou terminées",
      "performanceReports": "Rapports de performance",
      "performanceReportsDesc": "Recevez des résumés de performance quotidiens ou hebdomadaires",
      "creativeApprovals": "Approbations de créatifs",
      "creativeApprovalsDesc": "Soyez notifié lorsque les créatifs sont approuvés ou nécessitent une révision",
      "usageAlerts": "Alertes d'utilisation",
      "usageAlertsDesc": "Soyez notifié lorsque vous approchez ou dépassez les limites d'impressions",
      "pushNotifications": "Notifications push",
      "pushNotificationsDesc": "Recevez des notifications en temps réel dans le navigateur",
      "weeklyDigest": "Résumé hebdomadaire",
      "weeklyDigestDesc": "Recevez un résumé hebdomadaire de l'activité de votre compte"
    },
    "securitySettings": {
      "title": "Paramètres de sécurité",
      "subtitle": "Gérez la sécurité de votre compte",
      "changePassword": "Changer le mot de passe",
      "changePasswordDesc": "Mettez à jour votre mot de passe régulièrement pour la sécurité",
      "twoFactor": "Authentification à deux facteurs",
      "twoFactorDesc": "Ajoutez une couche de sécurité supplémentaire à votre compte",
      "notEnabled": "Non activé",
      "enabled": "Activé",
      "activeSessions": "Sessions actives",
      "currentSession": "Session actuelle",
      "activeNow": "Actif maintenant"
    },
    "billingSettings": {
      "title": "Facturation",
      "overview": "Aperçu",
      "usage": "Utilisation",
      "invoices": "Factures",
      "payments": "Paiements",
      "planHistory": "Historique du forfait",
      "currentPlan": "Forfait actuel",
      "changePlan": "Changer de forfait",
      "paymentMethod": "Méthode de paiement",
      "billingInfo": "Informations de facturation",
      "updatePayment": "Mettre à jour le paiement",
      "impressionsUsed": "Impressions utilisées",
      "cpmRate": "Tarif CPM",
      "overage": "Dépassement",
      "overageCost": "Coût du dépassement"
    },
    "saveChanges": "Enregistrer les modifications",
    "changesSaved": "Modifications enregistrées avec succès"
  },
  "tour": {
    "welcome": {
      "title": "Bienvenue sur Adventive !",
      "description": "Faisons une visite rapide pour vous aider à démarrer avec la plateforme. Vous apprendrez à créer des annonces, gérer des campagnes et accéder à des analyses puissantes."
    },
    "dashboard": {
      "title": "Votre tableau de bord",
      "description": "C'est votre centre de commande. Visualisez les métriques clés, les campagnes récentes et les actions rapides en un seul endroit. Le tableau de bord vous donne un aperçu en temps réel de vos performances publicitaires."
    },
    "createAd": {
      "title": "Créez votre première annonce",
      "description": "Cliquez ici pour commencer à créer des annonces interactives et engageantes. Notre constructeur glisser-déposer facilite la création d'annonces rich media sans codage.",
      "action": "Commencez par créer votre première annonce"
    },
    "campaigns": {
      "title": "Gérer les campagnes",
      "description": "Organisez et suivez toutes vos campagnes publicitaires. Définissez des budgets, des calendriers et des options de ciblage. Surveillez les performances en temps réel."
    },
    "insights": {
      "title": "Analyses puissantes",
      "description": "Plongez dans les performances de vos campagnes. Analysez les impressions, les clics, les taux d'engagement et le comportement de l'audience avec des analyses détaillées."
    },
    "contextiq": {
      "title": "Intelligence ContextIQ",
      "description": "Notre ciblage contextuel alimenté par l'IA vous aide à atteindre la bonne audience au bon moment. Analysez le contenu, trouvez des alignements de marque et découvrez des opportunités."
    },
    "gallery": {
      "title": "Galerie d'annonces",
      "description": "Accédez à tous vos créatifs en un seul endroit. Prévisualisez, dupliquez, modifiez ou archivez vos annonces. Gardez votre bibliothèque créative organisée et accessible."
    },
    "managedServices": {
      "title": "Services gérés",
      "description": "Besoin d'aide ? Notre équipe d'experts peut créer des annonces personnalisées pour vous. Soumettez une demande et nous nous occupons du travail créatif pendant que vous vous concentrez sur la stratégie."
    },
    "university": {
      "title": "Université Adventive",
      "description": "Améliorez vos compétences avec nos ressources d'apprentissage. Accédez à des tutoriels, des bonnes pratiques et des cours de certification pour devenir un expert en publicité interactive."
    },
    "complete": {
      "title": "Vous êtes prêt !",
      "description": "Vous êtes prêt à créer des annonces interactives incroyables. Si vous avez besoin d'aide à tout moment, consultez notre section Ressources ou contactez le support."
    },
    "skipTour": "Passer la visite",
    "getStarted": "Commencer"
  },
  "plan": {
    "base": "Base",
    "professional": "Professionnel",
    "enterprise": "Entreprise",
    "upgrade": "Améliorer",
    "current": "Forfait actuel",
    "perMonth": "/mois"
  },
  "brands": {
    "currentView": "Vue actuelle",
    "allBrands": "Toutes les marques",
    "selectBrand": "Sélectionner une marque",
    "addBrand": "Ajouter une marque",
    "noBrands": "Pas encore de marques ajoutées",
    "addBrandsHint": "Ajoutez des marques pour gérer plusieurs clients"
  },
  "errors": {
    "somethingWentWrong": "Quelque chose s'est mal passé",
    "tryAgain": "Veuillez réessayer",
    "notFound": "Page non trouvée",
    "unauthorized": "Accès non autorisé",
    "networkError": "Erreur réseau"
  },
  "time": {
    "justNow": "À l'instant",
    "minutesAgo": "il y a {{count}} min",
    "hoursAgo": "il y a {{count}} heure",
    "hoursAgo_plural": "il y a {{count}} heures",
    "daysAgo": "il y a {{count}} jour",
    "daysAgo_plural": "il y a {{count}} jours"
  }
};

export default fr;
